import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationButtonComponent } from './pagination-button.component';
import { StackModule } from '../stack/stack.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [PaginationButtonComponent],
  imports: [CommonModule, StackModule, ButtonModule],
  exports: [PaginationButtonComponent],
})
export class PaginationButtonModule {}
